import { FC, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { Select, Tooltip } from "src/components";
import { selectCompanyMembers } from "src/store/selectors";
import styles from './MembersSelect.module.scss'

type CompanyMember = {
  id: string;
  firstName?: string;
  lastName?: string;
  email: string;
};

export const MembersSelect: FC<{ 
    onSelect: (memberId: string) => void,
    selectedValue: string 
  }> = ({ onSelect, selectedValue }) => {
    const companyMembers = useSelector(selectCompanyMembers);
  
    const membersOptions = useMemo(() => {
      return Object.values(companyMembers).map((member: CompanyMember) => ({
        value: member.id,
        label: `${member.firstName || ''} ${member.lastName || ''}`.trim() || member.email,
      }));
    }, [companyMembers]);
  
    const handleSelect = useCallback((value: string) => {
      onSelect(value);
    }, [onSelect]);
  
    return (
      <Tooltip content="View alerts from other members.">
        <Select
          icon="PersonOutline"
          value={selectedValue}
          options={membersOptions}
          changeHandler={handleSelect}
          selectClassName={styles.select}
        />
      </Tooltip>
    );
  };